import keyMirror from 'fbjs/lib/keyMirror'

export default keyMirror({
  CATEGORY: null,
  BROWSE: null,
  PLP: null,
  BROWSE_FAILURE: null
})
